import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import FieldsTagsDt from '@/services/dataTransferModules/fieldsTagsDt'

export default function useFieldsTags(params = {}) {
	const fieldsTagsDt = new FieldsTagsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingFieldTag: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: fullFieldsTags,
		getEntities: getFieldsTags,

		createEntity: createFieldsTag,

		entity: fieldsTag,
		getEntity: getFieldsTag,

		entityPreview: fieldsTagsPreview,
		getEntityPreview: getFieldsTagsPreview,

		patchEntity: patchFieldsTag,
		updateEntity: putFieldsTag,

		deleteEntity: deleteFieldsTag,
	} = useBlProviders(
		fieldsTagsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error loading field tags!'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Error creating landbank tag',
				),

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error editing landbank tag',
				),

				showErrorNotificationForDeletingEntity: true,
				errorNotificationTextForDeletingEntity: $t('Error deleting landbank tag',
				),
			},
			params,
		),
	)

	return {
		flags,
		fullFieldsTags,
		fieldsTagsPreview,
		fieldsTag,

		getFieldsTags,
		getFieldsTagsPreview,
		getFieldsTag,
		createFieldsTag,
		patchFieldsTag,
		putFieldsTag,
		deleteFieldsTag,

		defaults,
	}
}
